import React from "react";
import "./HeroKube.css";
import { useTranslation, Trans } from "react-i18next";

// Si tu ajoutes plus tard des formats optimisés, décommente et importe-les :
// import heroAvif from "../../Pictuers/telealarme_hero@2x.avif";
// import heroWebp from "../../Pictuers/telealarme_hero@2x.webp";
// import heroMobileAvif from "../../Pictuers/telealarme_hero_m.avif";
// import heroMobileWebp from "../../Pictuers/telealarme_hero_m.webp";

export default function HeroKube() {
  const { t } = useTranslation();
  const productImage = "/images/Kube_part.png"; // PNG fond transparent

  return (
    <section className="hero-iss" aria-labelledby="iss-title" role="region">
      {/* BACKGROUND (conservé dans le JSX, masqué via CSS comme dans HeroTelealarmeISS) */}
      <picture className="hero-iss-bg" aria-hidden="true">
        {/* <source media="(max-width: 640px)" srcSet={heroMobileAvif} type="image/avif" />
        <source media="(max-width: 640px)" srcSet={heroMobileWebp} type="image/webp" />
        <source srcSet={heroAvif} type="image/avif" />
        <source srcSet={heroWebp} type="image/webp" /> */}
        <img
          src={"/images/Kube_part.png"}
          alt=""
          loading="eager"
          fetchpriority="high"
          decoding="async"
        />
      </picture>

      {/* Overlays graphiques (identiques) */}
      <div className="hero-iss-scrim" aria-hidden="true" />
      <div className="hero-iss-vignette" aria-hidden="true" />

      {/* CONTENU */}
      <div className="hero-iss-inner">
        <div className="iss-grid">
          {/* ===== Colonne gauche : titre, description, CTA ===== */}
          <div className="iss-col iss-col--copy">
            <header className="iss-header">
              <h1 id="iss-title" className="iss-title">{t("heroKube.title")}</h1>
              <p className="iss-subtitle">
                <Trans
                  i18nKey="heroKube.subtitle_html"
                  components={{ strong: <strong />, em: <em /> }}
                />
              </p>
            </header>

            <div className="hero-iss-actions" role="group" aria-label={t("heroKube.actions_aria")}>
              <a
                href="/devis"
                className="btn-solid"
                aria-label={t("heroKube.cta_aria")}
              >
                {t("heroKube.cta")}
              </a>
            </div>
          </div>

          {/* ===== Colonne droite : image produit ===== */}
          <figure className="iss-col iss-col--media">
            <img
              src={productImage}
              alt={t("heroKube.product_img_alt")}
              className="hero-iss-img"
              loading="eager"
              decoding="async"
            />
          </figure>
        </div>

        {/* JSON-LD (SEO Produit minimal) */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Product",
              name: t("heroKube.jsonld_name"),
              image: [productImage],
              description: t("heroKube.jsonld_description"),
              brand: { "@type": "Brand", name: "OPENlift" }
            })
          }}
        />
      </div>
    </section>
  );
}
